<div *ngIf="rut != null">
    <app-headerlog></app-headerlog>
</div>
<div *ngIf="rut == null">
    <app-header></app-header>
</div>
<router-outlet></router-outlet>
<app-footer></app-footer>
